import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AppRoutesContext } from './app-routes.context';

/**
 * AppRoutes - Route switcher that renders DM or Classic routes
 *
 * This component makes the routing decision transparent and explicit.
 * It uses useShouldUseCdmMode() based on local data modeling override, feature flag and CDM access group membership.
 * This component works together with the AppProviderSwitcher and need to be in sync with it.
 */
export const AppRoutes = () => {
  const {
    useShouldUseCdmMode,
    PageLoader,
    AppConfigErrorScreen,
    CdmRoutes,
    Routes,
  } = useContext(AppRoutesContext);

  const { shouldUseCdmMode, isLoading, isError } = useShouldUseCdmMode();
  const { t } = useTranslation('user');
  if (isError) {
    return (
      <AppConfigErrorScreen
        title={t(
          'USER_ERROR_LOCATION_MISSING_TITLE',
          'Error: Location is missing.'
        )}
        body={t(
          'USER_ERROR_LOCATION_MISSING_DESCRIPTION',
          "The InField admin has not defined any location yet, or you don't have access to any of the configured locations. Contact your admin if you have any questions."
        )}
      />
    );
  }
  if (isLoading) {
    return (
      <PageLoader
        infoText={t('LOADING_APPLICATION', 'loading application...')}
      />
    );
  }
  return shouldUseCdmMode ? <CdmRoutes /> : <Routes />;
};
